/*
 * @author: wayou
 * @date: 2018-10-11 16:16:16
 * @description: 图片预加载
 */

export interface IImgPreloaderOption {
    pipeline?: boolean;
    auto?: boolean;
    onProgress?: (url: string, loader: HTMLImageElement, index: number) => void;
    onError?: () => void;
    onComplete?: (loaded: string[], failed: string[]) => void;
}

export default class ImgPreloader {
    private options: IImgPreloaderOption;
    private queue: string[] = [];
    private completed: string[] = [];
    private errors: string[] = [];
    constructor(images: string[], options?: IImgPreloaderOption) {
        this.options = Object.assign(
            {
                pipeline: false,
                auto: true,
            },
            options,
        );

        this.addQueue(images);
        if (this.queue.length > 0 && this.options.auto) {
            this.start();
        }
    }

    public addQueue(images: string[]) {
        this.queue = images.slice();
    }

    public start() {
        const queue = this.queue;
        const len = queue.length;

        this.reset();

        if (!this.options.pipeline) {
            for (let i = 0; i < len; ++i) {
                this.load(queue[i], i);
            }
        } else {
            this.load(queue[0], 0);
        }
    }

    private reset() {
        this.completed = [];
        this.errors = [];
    }

    private load(src: string, index: number) {
        const loader = new Image();
        const options = this.options;

        loader.onerror = loader.onabort = () => {
            this.errors.push(src);
            if (options.onError) {
                options.onError();
            }
            this.checkProgress(src, loader);
            if (options.pipeline) {
                this.loadNext(index);
            }
        };

        loader.onload = () => {
            this.completed.push(src);
            this.checkProgress(src, loader);
            if (options.pipeline) {
                this.loadNext(index);
            }
        };

        loader.src = src;
    }

    private checkProgress(src: string, loader: HTMLImageElement) {
        const options = this.options;

        if (options.onProgress && src) {
            options.onProgress(src, loader, this.completed.length);
        }

        if (options.onComplete && this.completed.length + this.errors.length === this.queue.length) {
            options.onComplete(this.completed, this.errors);
        }
    }

    private loadNext(index: number) {
        index++;
        if (this.queue[index]) {
            this.load(this.queue[index], index);
        }
    }
}
